import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-mbs-fulldescription',
  templateUrl: './mbs-fulldescription.component.html',
  styleUrls: ['./mbs-fulldescription.component.scss'],
})
export class MbsFulldescriptionComponent implements OnInit {
  mbsitemData: any = {};
  item: string;
  fulldescription: string;

  constructor(
    public popoverController: PopoverController,
    public params: NavParams
    ) { 
      this.mbsitemData = this.params.get('mbsitem');
      this.item = this.mbsitemData.Mbs.ItemNum;
      this.fulldescription = this.mbsitemData.Mbs.Description;
    }

  ngOnInit() {}

  
  onModalDismiss() {
    this.popoverController.dismiss(false);
  }

}
